import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, IMG } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="py-16 pb-28 md:pb-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={IMG.logo}
                alt="The Plumbing & Electrical Co. logo"
                className="h-14 w-14 rounded-full border-2 border-[#adff01] object-cover"
              />
              <span className="font-display text-xs uppercase leading-tight">
                The Plumbing &amp;<br />Electrical Co.
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400">
              The blocked drains Perth specialists — serving all surrounding suburbs, from
              Rockingham to Joondalup and beyond.
            </p>
          </div>
          <div className="space-y-3 text-sm font-bold">
            <a
              href={PHONE_TEL}
              data-testid="footer-phone-link"
              className="flex items-center gap-3 text-zinc-200 transition-colors hover:text-[#adff01]"
            >
              <Phone className="h-4 w-4 text-[#adff01]" strokeWidth={2.5} />
              {PHONE_DISPLAY}
            </a>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email-link"
              className="flex items-center gap-3 text-zinc-200 transition-colors hover:text-[#adff01]"
            >
              <Mail className="h-4 w-4 text-[#adff01]" strokeWidth={2.5} />
              {EMAIL}
            </a>
            <p className="flex items-center gap-3 text-zinc-200">
              <MapPin className="h-4 w-4 text-[#adff01]" strokeWidth={2.5} />
              Perth, Western Australia
            </p>
          </div>
          <div className="flex flex-col items-start gap-4">
            <a
              href="#book-it-in"
              data-testid="footer-book-button"
              className="flex items-center gap-2 border-2 border-black bg-[#ff66c4] px-6 py-3 font-display text-xs uppercase tracking-wide text-black transition-transform hover:-translate-x-1 hover:-translate-y-1"
            >
              Book A Blocked Drain Visit
              <ArrowUpRight className="h-4 w-4" strokeWidth={3} />
            </a>
            <a
              href="https://www.tpeco.com.au"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-main-site-link"
              className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-white"
            >
              tpeco.com.au — full services & pricing
            </a>
          </div>
        </div>
        <p className="mt-12 border-t-2 border-white/10 pt-6 text-xs text-zinc-500">
          © {new Date().getFullYear()} The Plumbing &amp; Electrical Co. All prices include
          GST. Blocked Drains Perth — drain jetting, CCTV inspection &amp; drain
          unblocking across the Perth metro area.
        </p>
        <p className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-zinc-400" data-testid="footer-licences">
          WA Licences — Plumbing PL 8061 · BFL 2246 · Electrical EC 17738 · Gas GL 013140
        </p>
      </div>
    </footer>
  );
}
